import Event from './Event.js'
import APP from '../../../main.js'
// import issueFundGroup from "@/store/models/IssueFundGroup";

class Refund extends Event {
  constructor(rec) {
    super(rec);
  }

  get refund_cancels() {
    const relatedRefundCancelIds = this.constructor.employeeStore.event_relations
      .filter(rel => rel.parent_id === this.id && rel.child_type === 'RefundCancel')
      .map(rel => rel.child_id);

    return relatedRefundCancelIds.length > 0
      ? this.constructor.employeeStore.events.filter(event => relatedRefundCancelIds.includes(event.id))
      : [];
  }

  // refund_expected
  get refund_expectations() {
    return this.refund_cancels.map(refundCancel => refundCancel.refund_expected).filter(Boolean);
  }

  get matched_value() {
    return this.refund_expectations.reduce((sum, expectation) => sum + (expectation.value || 0), 0).toFixed(2);
  }

  get is_fully_matched() {
    return this.matched_value === (this.value || 0).toFixed(2);
  }

  get linked() {
    return this.is_fully_matched
  }

  // Determines if the refund needs to be matched with a refund expected
  // NORE: if you have a refund that doesn't need linking, make an issue_fund_group and then set require_refund_expected to false.
  get should_be_linked() {
    if (this.issue_fund_group) {
      return this.issue_fund_group.require_refund_expected
    } else {
      return true
    }
  }

}

export default Refund;
